import { InstallationGuide, PageWrapper } from '@src/components';
import { TicketForm } from './components/Ticket.Form';
import { useTranslation } from 'react-i18next';

export function HelpAndSupport() {
  const { t } = useTranslation();

  return (
    <PageWrapper rootClassName='flex flex-col items-center w-full lg:bg-gradient-to-b lg:from-wl-surface lg:to-wl-primary-container overflow-auto'>
      <div className='w-full md:max-w-[600px]'>
        <p className='text-M-32 mb-4 text-center text-wl-on-background'>
          {t('pages.ticket.getInTouch')}
        </p>
        <div className='max-w-[600px] mx-auto space-y-8 bg-wl-background px-4 py-4 md:px-10 md:py-9 rounded-xl mb-4 text-wl-on-background'>
          <TicketForm />
        </div>
      </div>
      <InstallationGuide className='max-w-[600px]' />
    </PageWrapper>
  );
}
